// Build & Version
let version     = '7.0';
let build       = "25.6.6.2"; // YY.M.D.#

module.exports = {
    version             : version,
    build               : build,
    releaseMomentUTC    : '2025-05-25 04:00:00'         // used to determine when to show new release
};

// 25.6.6.2     - Fixes: #25264;
// 25.6.6.1     - Fixes: #25253; 7.1-portfolio-display-numbers; 7.1-collapse-expand-in-menu;
// 25.6.5.1     - Fixes: #24759, #25240; 7.0-daily-report;
// 25.6.4.4     - Task view: css fix;
// 25.6.4.3     - Fixes: #25180;
// 25.6.4.2     - Fixes: #25230; Layout: Projects reset manual sorting fix;
// 25.6.4.1     - Fixes: #25224; 7.1-autofocus-to-search-input;
// 25.6.3.2     - GD Modals: ModalMoveTo_NoResultsFound fix 2;
// 25.6.3.1     - Fixes: #25217; GD Modals: ModalMoveTo_NoResultsFound fix;
// 25.6.2.1     - Fixes: #25197;
// 25.5.30.1    - Views: Projects list DND fix;
// 25.5.29.1    - Fixes: #25158, #25162; Project Info: Users onItemDeleteClick immediately remove item is implemented;;
// 25.5.28.2    - Fixes: #25117;
// 25.5.28.1    - Fixes: #25134, #25135;
// 25.5.27.2    - 7.0 release
// 25.5.27.1    - Fixes: #25091, #25114, #25121; 7.0-v8-health-settings;
// 25.5.26.2    - GD Modals: ModalAddUser_Right showCompanyUsers fix;
// 25.5.26.1    - hide archived pins ...
// 25.5.23.5    - Session: SessionProjectNew skip events from different company; GD Modals: Add users canAddCompanyUsers check is implemented;
// 25.5.23.4    - GD Model: ProjectUsers resetByProject fix; Task View: mentions save to local storage fix (User.toJSON() is implemented);
// 25.5.23.3    - Task View: ReplyFormOpen onSubmit fix; Layout: Menu Standard access add view fix;
// 25.5.23.2    - 7.0-v8;
// 25.5.23.1    - Fixes: #25079;
// 25.5.16.1    - Fixes: #24989 (task 24986);
// 25.5.14.3    - 6.23
// 25.5.14.2    - Fixes: #24957;
// 25.5.14.1    - Fixes: #24920;
// 25.5.13.2    - 6.29-asana-import fix;
// 25.5.13.1    - Fixes: #24948; 6.29-asana-import;
// 25.5.12.1    - Fixes: #24915;
// 25.5.8.1     - Fixes: #24875;
// 25.5.6.2     - Fixes: #24884;
// 25.5.6.1     - 6.29-conflict-new
// 25.5.2.1     - GD: API Request resendRequest and ajaxRequestV2 fix (for print-2-pdf as it has no gd.auth);
// 25.5.1.1     - 6.29-auth-fixes;
// 25.4.30.1    - Fixes: #24765; 6.29-auth-fixes;
// 25.4.29.1    - new auth engine
// 25.4.28.5    - Fixes: #24781;
// 25.4.28.4    - Fixes: #24814b;
// 25.4.28.3    - Fixes: #24814;
// 25.4.28.2    - Fixes: #24795;
// 25.4.28.1    - Fixes: #24769;
// 25.4.25.2    - Fixes: #24772;
// 25.4.25.1    - Fixes: #24755;
// 25.4.24.2    - Fixes: #24757;
// 25.4.24.1    - Fixes: #24754;
// 25.4.23.3    - Fixes: #23410;
// 25.4.23.2    - 6.next-project-type-field
// 25.4.23.1    - Fixes: #24699;
// 25.4.21.2    - My Tasks: MyTasksLocalSettings groupBy2 fix;
// 25.4.21.1    - 6.next-calendar-view-project;
// 25.4.18.3    - Fixes: #24675b;
// 25.4.18.2    - Fixes: #24675;
// 25.4.18.1    - Fixes: #24669, #24671;
// 25.4.17.4    - Fixes: #24656;
// 25.4.17.3    - Fixes: #24655;
// 25.4.17.2    - Fixes: #24496;
// 25.4.17.1    - Fixes: #24630, #24639;
// 25.4.16.1    - 6.Next-group-by;
// 25.4.15.1    - Fixes: #24526;
// 25.4.14.2    - Fixes: #24555;
// 25.4.14.1    - Fixes: #24525;
// 25.4.10.1    - Fixes: #24532;
// 25.4.9.2     - Fixes: #24509;
// 25.4.9.1     - Fixes: #24494;
// 25.4.8.2     - 6.22
// 25.4.8.1     - Fixes: #24488;
// 25.4.7.1     - Fixes: #24457;
// 25.4.1.3     - Fixes: #24399;
// 25.4.1.2     - new icons cache fix;
// 25.4.1.1     - new icons;
// 25.3.30.1    - Saved reports
// 25.3.27.1    - 6.22-icons;
// 25.3.26.2    - Fixes: #24152;
// 25.3.26.1    - Fixes: #24148, #24149;
// 25.3.25.3    - Custom Views: Calendar, Gantt, Board, Workload Preferences save fix;
// 25.3.25.2    - Fixes: #24138;
// 25.3.25.1    - Fixes: #24132;
// 25.3.24.2    - Fixes: #24079;
// 25.3.24.1    - Fixes: #24078;
// 25.3.22.1    - 6.21
// 25.3.21.3    - 6.19-VIEW-IN-STRUCTURE-2;
// 25.3.21.2    - Fixes: #24069
// 25.3.21.1    - Fixes: #24077, #24086;
// 25.3.20.1    - Fixes: #23775;
// 25.3.18.1    - Fixes: #24054;
// 25.3.17.1    - Fixes: #23950;
// 25.3.13.1    - Fixes: #23929;
// 25.3.12.2    - Fixes: #23947;
// 25.3.12.1    - Fixes: #23927;
// 25.3.9.4     - Fixes: #23914;
// 25.3.9.3     - Request Forms: fixes;
// 25.3.9.2     - GD Modules: Task List Quick Filter system status fix;
// 25.3.9.1     - Fixes: 23879;
// 25.3.7.3     - 6.20 (reports) + automations condition
// 25.3.7.2     - Fixes: #23552;
// 25.3.7.1     - Fixes: #23604, #23851, #23858;
// 25.3.6.1     - Fixes: #23815;
// 25.3.5.1     - 6.17-click-up-import-fast instruction added;
// 25.3.4.2     - 6.17-click-up-import-fast fix;
// 25.3.4.1     - 6.17-click-up-import-fast
// 25.2.28.2    - Workload and Shared Calendar fixes;
// 25.2.28.1    - Fixes: #23729;
// 25.2.27.1    - Gantt small fixes, shared view board custom view fix;
// 25.2.26.2    - Link in Structure: edit source and click fix;
// 25.2.26.1    - Fixes: #23701;
// 25.2.24.1    - Fixes: #23687;
// 25.2.19.1    - Fixes: #23596, #23600;
// 25.2.17.1    - Fixes: #23559;
// 25.2.14.2    - Fixes: #23531; 6.next-my-work-more-menu
// 25.2.14.1    - 6.Next-report-timer
// 25.2.13.3    - 6.19
// 25.2.13.2    - Fixes: #23557;
// 25.2.13.1    - Fixes: #23533, #23544;
// 25.2.12.1    - Fixes: #23539;
// 25.2.11.4    - Fixes: #23525c;
// 25.2.11.3    - Fixes: #23534, #23536;
// 25.2.11.2    - Fixes: #23525b;
// 25.2.11.1    - Fixes: #23482, #23525;
// 25.2.10.1    - Fixes: #23398, #23513;
// 25.2.6.4     - Fields3: FieldSelectField_Popover convertFieldsStructureToConfig fix;
// 25.2.6.3     - Fixes: #23458;
// 25.2.6.2     - 6.17-REPORTS-RC1;
// 25.2.6.1     - 6.next-Gantt, 6.next-MULTISORT-RC1;
// 25.2.5.2     - Fixes: #22440; 6.16-attachment-custom-field
// 25.2.5.1     - Fixes: #22746;
// 25.2.4.3     - Add api key from google
// 25.2.4.2     - 6.next-CUSTOM-FIELDS-RC1, 6.Next-page-subpages-2
// 25.2.4.1     - 6.Next-clickup-markdown-conversion
// 25.2.3.2     - Page: disabled small fix;
// 25.2.3.1     - 6.Next-page-subpages
// 25.1.31.1    - Fixes: #25056;
// 25.1.28.2    - 6.18
// 25.1.28.1    - Fixes: #25046;
// 25.1.24.2    - Fixes: #25015, #25019, #25021;
// 25.1.24.1    - Fixes: #24913, #24980;
// 25.1.22.2    - 6.17-add-view;
// 25.1.22.1    - Fixes: #24988, #24990;
// 25.1.16.3    - Fixes: #24935;
// 25.1.16.2    - 6.17-PROJECT-VIEWS-RC1
// 25.1.16.1    - Fixes: #24929;
// 25.1.15.2    - 6.17
// 25.1.15.1    - Fixes: #24901;
// 25.1.14.1    - Fixes: #24876, #24883;
// 25.1.13.1    - Fixes: #24848;
// 25.1.10.1    - 6.17-VALIDATIONS-RC1; Fixes: #24381;
// 25.1.8.3     - Trash
// 25.1.8.2     - Fixes: #24680;
// 25.1.8.1     - Fixes: #24507, #24797;
// 25.1.7.1     - 6.16
// 24.12.27.1   - Fixes: #24691;
// 24.12.25.1   - Expenses release
// 24.12.24.2   - Fixes: #24655;
// 24.12.24.1   - Fixes: #24651;
// 24.12.23.1   - Fixes: #24602;
// 24.12.18.2   - Fixes: #24543;
// 24.12.18.1   - Fixes: #24581;
// 24.12.13.1   - Fixes: #24557;
// 24.12.12.1   - 6.XXX-Bulk-action-selector-with-shift;
// 24.12.10.2   - Fixes: #24494;
// 24.12.10.1   - Fixes: #24457;
// 24.12.9.1    - Fixes: #24491;
// 24.12.4.2    - GD Modules: Gantt rows numeration order fix;
// 24.12.4.1    - Fixes: #24446;
// 24.12.2.1    - Fixes: #24434;
// 24.11.29.1   - GD UI: ReorderListNoDiv useLayoutEffect fix (isEqual is slow in Projects menu);
// 24.11.28.1   - GD Modules: Table/List customer onClick item fix;
// 24.11.27.2   - 6.14
// 24.11.27.1   - Fixes: #24400;
// 24.11.26.2   - Fixes: 6.14-AUTOMATIONS-RC1;
// 24.11.26.1   - Fixes: #24369;
// 24.11.25.3   - Fixes: #24249;
// 24.11.25.2   - Fixes: #24283;
// 24.11.25.1   - Fixes: #24377;
// 24.11.22.2   - Fixes: patch-support-ticket;
// 24.11.22.1   - Fixes: #24182;
// 24.11.20.3   - GD Settings: gd.table renderMode default value is modified;
// 24.11.20.2   - Fixes: #21380;
// 24.11.20.1   - Fixes: #23749; GD Components: HoverComponent fix; 6.14-Performance-table-virtualized;
// 24.11.19.1   - Fixes: #24339, #24304;
// 24.11.18.2   - Custom Entities
// 24.11.18.1   - Fixes: #24315;
// 24.11.14.2   - Fixes: #24310;
// 24.11.14.1   - Fixes: #24270;
// 24.11.13.3   - 6.13
// 24.11.13.2   - Performance patch + enabl;e community access
// 24.11.13.1   - Fixes: #24287; 6.13-documents;
// 24.11.8.3    - patch
// 24.11.8.2    - Fixes: #24223;
// 24.11.8.1    - Fixes: #23639, #24127;
// 24.11.7.1    - 6.12
// 24.11.6.2    - 6.12
// 24.11.6.1    - Fixes: #24117, #24202;
// 24.11.5.2    - Fields3: FieldMultiselect_TableCell onOptionClick hidePopover property is added, FieldMultiselect_TableCellValue update fix;
// 24.11.5.1    - 6.12-TAGS-RC1;
// 24.10.31.2   - 6.14-project-page-update-fix;
// 24.10.31.1   - Fixes: #24108;
// 24.10.29.2   - Fixes: #24111;
// 24.10.29.1   - Fixes: #24102;
// 24.10.28.2   - 6.12-workload-reports;
// 24.10.28.1   - Fixes: #24100;
// 24.10.25.1   - Fixes: #24078;
// 24.10.23.5   - Fixes: #24038;
// 24.10.23.4   - Fixes: #23596;
// 24.10.23.3   - Fixes: #24030b;
// 24.10.23.2   - Fixes: #24030, #24037;
// 24.10.23.1   - Fixes: #22737;
// 24.10.22.1   - Fixes: #24033;
// 24.10.21.1   - Fixes: #23723;
// 24.10.18.5   - Fixes: #23748c;
// 24.10.18.4   - 6.11
// 24.10.18.3   - Fixes: #23748b;
// 24.10.18.2   - Fixes: #23645, #23748, #23750;
// 24.10.18.1   - Fixes: #23738, #23743, #23744;
// 24.10.17.3   - Fixes: #23735;
// 24.10.17.2   - after merge;
// 24.10.17.1   - 6.10-link-embed-RC1;
// 24.10.16.1   - Fixes: #23708, #23712;
// 24.10.14.3   - Fixes: #23681;
// 24.10.14.2   - Fixes: #23680;
// 24.10.14.1   - Fixes: 6.11-WORSCHEDULE-RC1;
// 24.10.11.3   - Fixes: #23589, #23640, #23641, #23642, #23644;
// 24.10.11.2   - Fixes: #23592d;
// 24.10.11.1   - Fixes: #23592c;
// 24.10.10.4   - Fixes: #23592b;
// 24.10.10.3   - Fixes: #23622;
// 24.10.10.2   - copy task users
// 24.10.10.1   - Fixes: #23592;
// 24.10.9.2    - Fixes: #23588;
// 24.10.9.1    - Fixes: #23601;
// 24.10.7.3    - 6.10 release
// 24.10.7.2    - Fixes: #23561;
// 24.10.7.1    - Fixes: #23550;
// 24.10.2.5    - Fixes: #23513;
// 24.10.2.4    - Fixes: #23458;
// 24.10.2.3    - Fixes: #23505;
// 24.10.2.2    - Fixes: #23486b;
// 24.10.2.1    - Fixes: #22102b, #23486;
// 24.10.1.3    - 6.10-task-view-action-buttons;
// 24.10.1.2    - Fixes: #23467b;
// 24.10.1.1    - Fixes: #23450;
// 24.9.30.2    - Fixes: #23466;
// 24.9.30.1    - Fixes: #23467; 6.11-growl-new-design;
// 24.9.25.1    - Fixes: #22903; 6.10-project-view-management;
// 24.9.24.1    - Fixes: #22506, #22745;
// 24.9.23.3    - Fixes: #23403;
// 24.9.23.2    - Fixes: #23363;
// 24.9.23.1    - Fixes: #23377;
// 24.9.20.2    - Fixes: #23361b;
// 24.9.20.1    - Fixes: #23359, #23361;
// 24.9.19.5    - 6.9
// 24.9.19.4    - Fixes: #23351;
// 24.9.19.3    - Fixes: #23350;
// 24.9.19.2    - Fixes: #23093;
// 24.9.19.1    - Fixes: #22102;
// 24.9.18.2    - Fixes: #23084;
// 24.9.18.1    - Fixes: #22805;
// 24.9.17.2    - Fixes: #22926, #22927;
// 24.9.17.1    - Fixes: #22745, #22920;
// 24.9.16.1    - Fixes: #22875, 6.6-page;
// 24.9.11.1    - Fixes: #22743;
// 24.9.10.1    - Fixes: #22713, #22738;
// 24.9.6.4     - disable sentry by default
// 24.9.6.3     - fix table less errors
// 24.9.6.2     - fix Calendar
// 24.9.6.1     - Fixes: #22678, #22679, #22707;
// 24.9.5.3     - 6.8
// 24.9.5.2     - Fixes: #22706;
// 24.9.5.1     - Fixes: #20268b;
// 24.9.4.2     - Fixes: #22668;
// 24.9.4.1     - Fixes: #22656, #22669;
// 24.9.3.2     - Fixes: #22603, #22664;
// 24.9.3.1     - Fixes: #22622, #22642
// 24.9.2.2     - Fixes: #22646;
// 24.9.2.1     - 6.9-time-report-limits;
// 24.8.30.1    - Fixes: #22149;
// 24.8.23.1    - Fixes: #22205b;
// 24.8.22.1     - gCal msCal sync release
// 24.8.21.2    - Fixes: #22481;
// 24.8.21.1    - Fixes: #21892, #22513;
// 24.8.19.1    - Fixes: #22351, #22495;
// 24.8.16.3    - Clock In
// 24.8.16.2    - 6.7 release
// 24.8.16.1    - Fixes: #22487;
// 24.8.14.1    - add view menu
// 24.8.13.3    - GD: PermissionsCustomView getAllAvailable fix;
// 24.8.13.2    - 6.7-Clock-In-Out fixes;
// 24.8.13.1    - 6.7-Clock-In-Out;
// 24.8.12.3    - Fixes: #20268b;
// 24.8.12.2    - Fixes: #20268;
// 24.8.12.1    - Fixes: #22412;
// 24.8.8.1     - Fixes: #22379;
// 24.8.6.1     - 6.6
// 24.8.5.1     - Fixes: #21035, #22336;
// 24.8.1.1     - All projects;
// 24.7.31.1    - Fixes: #22046;
// 24.7.30.1    - Fixes: #22199;
// 24.7.29.1    - Fixes: #21892;
// 24.7.25.1    - fix create project non manager
// 24.7.24.1    - Fixes: #22205;
// 24.7.23.2    - Fixes: #22181;
// 24.7.23.1    - Fixes: #22123;
// 24.7.22.1    - Fixes: #22162, #22166;
// 24.7.18.2    - webhook history
// 24.7.18.1    - Fixes: #22098;
// 24.7.16.1    - isBillable time
// 24.7.15.1    - Fixes: #22056;
// 24.7.11.1    - Fixes: #21962, #21981;
// 24.7.10.2    - Fixes: #21982;
// 24.7.10.1    - Fixes: #21994;
// 24.7.8.1     - Fixes: #21930; fixes from 6.4-performance;
// 24.7.6.1     - Hourly cost history
// 24.7.5.2     - Fixes: #21929;
// 24.7.5.1     - Fixes: #21849, #21884, #21892;
// 24.7.4.1     - Fixes: #21819;
// 24.7.2.1     - Fixes: #21863;
// 24.6.25.1    - patch
// 24.6.21.1    - beta release 6.5
// 24.6.10.1    - 6.4 - Goals release
// 24.6.7.1     - Fixes: #21623;
// 24.6.6.1     - Fixes: #21604;
// 24.6.5.1     - Fixes: #20003, #21575;
// 24.6.3.1     - Fixes: #21461, #21573;
// 24.5.31.2    - Fixes: #21540;
// 24.5.31.1    - merged with 6.3-goals;
// 24.5.28.1    - merged with 6.3-goals;
// 24.5.24.2    - merged with 6.3-goals;
// 24.5.24.1    - Fixes: #21465;
// 24.5.23.1    - merged with 6.3-goals;
// 24.5.21.1    - Fixes: #21426;
// 24.5.20.2    - Fixes: #21374;
// 24.5.20.1    - Fixes: #21400;
// 24.5.15.2    - Snapshots gantt improvemnt
// 24.5.15.1    - Fixes: #21264, #21268;
// 24.5.13.1    - Fixes: #21178, #21202, #21246;
// 24.5.6.1     - ui5: popover menu css fix;
// 24.4.30.2    - 6.3
// 24.4.30.1    - Fixes: #19613;
// 24.4.22.1    - Fixes: #20999;
// 24.4.19.1    - Fixes: #20206, #20998, #21001;
// 24.4.17.2    - Fixes: #20894b;
// 24.4.17.1    - Fixes: #20894;
// 24.4.16.1    - Fixes: #20959, #20961;
// 24.4.11.2    - Fixes: Task View: reply onSubmit fix;
// 24.4.11.1    - Fixes: #20272;
// 24.4.10.1    - Fixes: #19916, #20189, #20259, #20263, #20264;
// 24.4.5.1     - Fixes: #20191;
// 24.4.3.1     - Fixes: #20123b;
// 24.4.2.3     - Fixes: #20123;
// 24.4.2.2     - Fixes: #20118b;
// 24.4.2.1     - Fixes: #20118;
// 24.4.1.2     - 6.2
// 24.4.1.1     - Fixes: #20075; 6.1-chats
// 24.3.30.1    - time reports by task type
// 24.3.29.1    - Fixes: #20037;
// 24.3.28.3    - task message delete reaction api call change
// 24.3.28.2    - 6.2-session-reset-fix
// 24.3.28.1    - Fixes: #19979, #20030;
// 24.3.27.1    - automations addons
// 24.3.26.1    - Fixes: #19824;
// 24.3.22.1    - Fixes: #19916, #19927, #19946, #19961;
// 24.3.21.1    - 6.1
// 24.3.20.1    - checkout promo code
// 24.3.18.3    - Fixes: #19751c;
// 24.3.18.2    - Fixes: #19751b;
// 24.3.18.1    - Fixes: #19751;
// 24.3.15.2    - Fixes: #19408, #19836;
// 24.3.15.1    - Fixes: #19828;
// 24.3.14.1    - Fixes: #19511, #19762;
// 24.3.12.2    - Fixes: #19755;
// 24.3.12.1    - Fixes: #19581;
// 24.3.11.1    - Fixes: #18004, #19710;
// 24.3.7.3     - AppTaskView: taskView_logView is reverted;
// 24.3.7.2     - AppTaskView: taskView_logView is commented out;
// 24.3.7.1     - 6.1-task-view-log
// 24.3.6.2     - Fix login warning + MESSAGE REACTIONS !
// 24.3.6.1     - Fixes: #19652;
// 24.3.5.1     - 2fa personal
// 24.2.29.2    - Fixes setting links (Vic);
// 24.2.29.1    - Fixes: #19531, #19537, #19539;
// 24.2.28.1    - Fixes: #19364;
// 24.2.26.4    - Fixes: #19504, organization delete user app refactor;
// 24.2.26.3    - Fixes: #19350, #19417, #19491, #19494;
// 24.2.25.2    - micro
// 24.2.25.1    - 6.0 (Vic)


